import PurchaseModalController from 'utils/purchase_modal/purchase_modal_component/purchase-modal-controller';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import {
  REBUY_UPGRADE_COMPLETE,
  REBUY_POPUP_COMPLETE,
  REBUY_POPUP_ERROR,
  REBUY_UPGRADE_ERROR,
} from 'components/analytics/conversions/constants/actions';

export default class ConfirmPaymentModalController extends PurchaseModalController {
  static values = {
    upgradeFromCreditPlan: { type: Boolean, default: false },
  };

  sendPurchaseEvents() {
    const action = this.upgradeFromCreditPlanValue ? REBUY_UPGRADE_COMPLETE : REBUY_POPUP_COMPLETE;
    sendTrackingEvent({ data: { action } });
  }

  sendErrorEvents() {
    const action = this.upgradeFromCreditPlanValue ? REBUY_UPGRADE_ERROR : REBUY_POPUP_ERROR;
    sendTrackingEvent({ data: { action } });
  }

  submitPurchase = (event) => {
    if (this.requiresCheckoutValue) {
      event.preventDefault();
      const planCheckoutTarget = JSON.parse(this.selectedPlanValue).remote_id;

      window.location.href = `${this.checkoutUrlValue}/${planCheckoutTarget}`;
    } else {
      super.submitPurchase();
    }
  }
}
